<div style="width: 100%; display: flex">
  <div style="width: 20%">
    <mat-list role="list">
      <mat-list-item routerLink="/sample-pages/buttons" routerActive="Active" i18n> Buttons </mat-list-item>
      <mat-list-item routerLink="/sample-pages/icons" routerActive="Active" i18n> Icons </mat-list-item>
      <mat-list-item routerLink="/sample-pages/menu" routerActive="Active" i18n> Menu </mat-list-item>
      <mat-list-item routerLink="/sample-pages/input" routerActive="Active" i18n> Input </mat-list-item>
      <mat-list-item routerLink="/sample-pages/plugin" routerActive="Active" i18n> Plugin </mat-list-item>
    </mat-list>
  </div>
  <div style="width: 80%; height: calc(100vh - var(--nav-bar-header-height)); overflow-y: auto">
    <router-outlet></router-outlet>
  </div>
</div>
